import apiClient from "./ApiService";

export const getIndustryTypes = async () => {
    return await apiClient.get("/adelselfservice/selfservice/industries");
}

export default getIndustryTypes;
